import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AvatarOrInitials } from 'utils/avatarUtils';

const Profile = ({ auth, isCollapsed }) => {
  if (!auth?.id) {
    return null;
  }

  const username = auth.username || auth.email || 'user';

  return (
    <div className={`sidebar-profile ${isCollapsed ? 'sidebar-profile--collapsed' : ''}`}>
      <RouterLink
        to={`/profile/${auth.id}`}
        className="sidebar-profile-link"
        title={`@${username}`}
      >
        <AvatarOrInitials
          avatarUrl={auth.avatar}
          name={auth.name}
          lastN={auth.lastN}
          emailFallback={auth.email}
          className="sidebar-profile-avatar"
          alt={username}
        />
        <span className="sidebar-profile-username">@{username}</span>
      </RouterLink>
    </div>
  );
};

Profile.propTypes = {
  auth: PropTypes.object,
  isCollapsed: PropTypes.bool,
};

function mapStateToProps(reducer) {
  return {
    auth: reducer.session.auth,
  };
}

export default connect(mapStateToProps, null)(Profile);
